import { FC, useEffect, useState } from 'react'
import Button from 'components/Button'
import { scrollToElement } from 'utils/pageUtils'
import { contactFormId } from 'shared/constants'
import Logo from './Logo'
import Stat from './Stat'
import ExamplePill from './ExamplePill'
import {
  ExamplePillsContainer,
  MainContainer,
  ProjectInfoContainer,
  ProjectInfoFirstSection,
  ProjectStatsContainer,
} from './styled'
import ExampleVideo from './ExampleVideo'
import Container from 'components/Container'
import { Box } from '@mui/material'
import LoadingState from './LoadingState'

const ProjectDetails: FC<IProjectContextSectionProps> = ({ project }) => {
  const [currentMedia, setCurrentMedia] = useState('')
  const [videoIndex, setVideoIndex] = useState(0)

  const handleGetInTouchClick = () => {
    scrollToElement(`#${contactFormId}`, { block: 'center' })
  }

  useEffect(() => {
    if (project && project.examples.length > 0) {
      setCurrentMedia(
        project.examples[0].video || project?.showcaseVideo || project?.showcaseImage?.fullSize,
      )
    }
  }, [project])

  return (
    <>
      {project && project.examples.length > 0 ? (
        <MainContainer>
          <Container>
            <ProjectInfoContainer>
              <ProjectInfoFirstSection sx={{ justifyContent: 'center' }}>
                <Logo image={project.logo.fullSize} alt={project.logoAltText} />
                <ProjectStatsContainer>
                  {project.stats.map((stat, index) => (
                    <Stat key={index} stat={stat} />
                  ))}
                </ProjectStatsContainer>
                <Box component="div">
                  <Button buttonvariant="cta2" onClick={handleGetInTouchClick}>
                    Build yours too!
                  </Button>
                </Box>
              </ProjectInfoFirstSection>

              <ExampleVideo
                currentMedia={currentMedia}
                videoIndex={videoIndex}
                setVideoIndex={setVideoIndex}
                examplesLength={project.examples.length}
                examples={project.examples}
                defaultDevice={project.deviceType}
                setCurrentMedia={setCurrentMedia}
                projectShowcaseVideo={project?.showcaseVideo}
                projectShowcaseImage={project?.showcaseImage?.fullSize}
              />
            </ProjectInfoContainer>
          </Container>
          <ExamplePillsContainer>
            {project.examples.length > 1 &&
              project.examples.map((example, index) => (
                <ExamplePill
                  key={index}
                  example={example}
                  setCurrentMedia={setCurrentMedia}
                  setVideoIndex={setVideoIndex}
                  index={index}
                  projectShowcaseVideo={project?.showcaseVideo}
                  videoIndex={videoIndex}
                  projectShowcaseImage={project?.showcaseImage?.fullSize}
                />
              ))}
          </ExamplePillsContainer>
        </MainContainer>
      ) : (
        <LoadingState />
      )}
    </>
  )
}

export default ProjectDetails
